import { fetchAsync } from '@engagehub/core';
import { AxiosError } from 'axios';
import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { adminApiVersion } from '@utils/store/constants';
import { IConfigureTemplateFields } from '../hooks';

export const useConfigureTemplate = (): UseMutationResult<
  unknown,
  AxiosError,
  IConfigureTemplateFields,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    (values: IConfigureTemplateFields) =>
      fetchAsync(`/br-admin/templates/${values.templateId}`, {
        method: 'PUT',
        headers: {
          'x-eh-scope': values.targetScope,
        },
        params: {
          'api-version': adminApiVersion,
        },
        data: {
          ...values,
          createdBy: 'Microsoft@microsoft.com',
        },
      }),
    {
      onSuccess: () => queryClient.invalidateQueries(['create-customer-process']),
    },
  );
};
